const GCS_HOST = 'storage.googleapis.com';
const IMGPROXY_BASE = 'https://img.tenkusports.com';

export const imageVariant = (url, preset) => {
  if (!url) return undefined;
  let parsed;
  try {
    parsed = new URL(url);
  } catch {
    return url;
  }
  if (parsed.host !== GCS_HOST) return url;
  const path = parsed.pathname.replace(/^\//, '');
  const slash = path.indexOf('/');
  if (slash <= 0 || slash === path.length - 1) return url;
  return `${IMGPROXY_BASE}/unsafe/${preset}/plain/gs://${path.slice(0, slash)}/${path.slice(slash + 1)}`;
};
